import { environment } from 'src/environments/environment';
import {Component, OnInit, AfterViewInit, OnDestroy} from '@angular/core';
import {BaseComponent} from '../../base/base.component';
import {ActivatedRoute, Router} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import {TranslateService} from '@ngx-translate/core';
import {CardStore} from '../../model/kamban/card-store';
import {
    Action,
    Committee,
    CommitteesGQL,
    CreateActionGQL,
    CreateActionInput,
    CreateActionResponsibleInput,
    CreateActionIdeaInput,
    GetUnitiesGQL,
    GetUsersGQL,
    Idea,
    IdeaByStatusGQL,
    Kamban,
    SearchActionGQL,
    SearchActionInput,
    SearchActionQuery,
    Unity,
    User,
    UpdateActionGQL,
    UpdateActionInput,
    ActionComment,
    CreateActionCommentGQL,
    CreateActionCommentInput,
    CreateActionCommentActionInput,
    CreateActionTaskGQL,
    CreateActionTaskInput,
    ActionTask,
    UpdateActionTaskStatusGQL,
    ActionFile,
    RemoveActionTaskGQL,
    UpdateActionStatusGQL,
    GetIdeaGQL,
    RemoveActionFileGQL,
    GetIdeaCommiteeByIdGQL,
    SearchActionHistoryQuery,
    SearchActionHistoryGQL,
    ActionHistoryPage, 
    Country, 
    GetCountriesGQL,
    GetIdeaQuery,
    UpdateIdeaGQL,
    UpdateIdeaInput,
    UpdateIdeaStatusInput,
    UpdateIdeaStatusGQL
} from '../../../generated/graphql';
import {QueryRef} from 'apollo-angular';
import {UserService} from '../../service/user.service';
import { FileService } from 'src/app/service/file.service';
import { CreateKaizenIdeaGQL } from 'src/generated/graphql/ideaKaizen.graphql';

declare var $: any;

const extensions = [
    'jpeg', 
    'png', 
    'jfif', 
    'pdf', 
    'doc', 
    'xlt', 
    'xls', 
    'xlsx', 
    'sheet', 
    'xml', 
    'ppt', 
    'pptx', 
    'txt', 
    'plain', 
    'docx'
];

const imageTypes = ['png', 'jpg', 'jpeg', 'jfif'];
const mimeTypePrefix = 'image/';

@Component({
    selector: 'app-kamban',
    templateUrl: './kamban.component.html',
    styleUrls: ['./kamban.component.scss'],
})
export class KambanComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
    user: User = new User();
    cardStore: CardStore;
    searchActionInput: SearchActionInput = new SearchActionInput();
    selectIdea: Idea = undefined;
    listKamban: Kamban[] = [];
    listIdeas: Idea[] = [];
    listIdeasAction: Idea[] = [];
    listUnity: Unity[] = [];
    listCountry: Country[] = [];
    listCommittee: Committee[] = [];
    committee: Array<Committee> = [];
    newIdeaKaizenId: string = ''
    updateIdeaInput: UpdateIdeaInput = new UpdateIdeaInput();


    listUser: User[] = [];
    searchActionQuery: QueryRef<SearchActionQuery>;
    searchActionHistoryQuery: QueryRef<SearchActionHistoryQuery>;
    modelAction: Action;
    modelActionHistory: ActionHistoryPage = new ActionHistoryPage();
    responsible: string;
    comments: any;
    task: any;
    defaultPhoto = 'https://www.pontoxtecidos.com.br/static/567/sku/164485009798408.jpg';

    file: File = null;
    files: File[];
    thumpPath: (string | ArrayBuffer)[];
    thumpName: string = null;
    croppedImage: any = null;
    createFiles: File[] = [];
    imageUrl: string = environment.bucketUrl;

    dropdownSettingsUnities = {};
    selectedUnityItems: { id: string; nameCode: string }[];
    selectedItemsResponsible: { id: string; name: string }[];

    selectStatus = 'pending';
    currentStatus: string;
    updateIdeaStatusInput: UpdateIdeaStatusInput = new UpdateIdeaStatusInput();

    page = 1;
    parmId: string;

    idea: Idea = new Idea();

    dropSettings: any = {
        singleSelection: false,
        idField: 'id',
        textField: 'name',
        selectAllText: 'Marcar todos',
        unSelectAllText: 'Desmarcar todos',
        itemsShowLimit: 3,
        allowSearchFilter: true
    };

    addAction: boolean;
    unityCountry: boolean;

    getIdeaQuery: QueryRef<GetIdeaQuery>;



    constructor(public router: Router,
                public loading: NgxSpinnerService,
                public route2: ActivatedRoute,
                public translate: TranslateService,
                public userService: UserService,
                private searchActionGQL: SearchActionGQL,
                private searchActionHistoryGQL: SearchActionHistoryGQL,
                private getIdeasGQL: IdeaByStatusGQL,
                private getUnitiesGQL: GetUnitiesGQL,
                private getCountriesGQL: GetCountriesGQL,
                private committeesGQL: CommitteesGQL,
                private getUsersGQL: GetUsersGQL,
                private createActionGQL: CreateActionGQL,
                private updateActionGQL: UpdateActionGQL,
                private createKaizenIdeaGQL: CreateKaizenIdeaGQL,
                private createActionCommentGQL: CreateActionCommentGQL,
                private createActionTaskGQL: CreateActionTaskGQL,
                private updateActionTaskStatusGQL: UpdateActionTaskStatusGQL,
                private removeActionTaskGQL: RemoveActionTaskGQL,
                private updateActionStatusGQL: UpdateActionStatusGQL,
                private getIdeaGQL: GetIdeaGQL,
                private getIdeaCommiteeByIdGQL: GetIdeaCommiteeByIdGQL,
                private removeActionFileGQL: RemoveActionFileGQL,
                private fileService: FileService,
                private UpdateIdeaGQL: UpdateIdeaGQL,
                private UpdateIdeaStatusGQL: UpdateIdeaStatusGQL,
    ) {
        super(router, loading, translate);
        this.files = [];
        this.thumpPath = [];
        this.modelAction = new Action();
        this.modelAction.files = [];
    }

    ngOnInit(): void {
        this.userService.user.subscribe({
            next: data => {
                this.user = data as User;
                this.userProfile();
            }
        });
        this.dropdownSettingsUnities = {
            singleSelection: true,
            idField: 'id',
            textField: 'nameCode',
            itemsShowLimit: 1,
            enableCheckAll: false,
            allowSearchFilter: true,
            maxHeight: 500,
        };
        this.searchActionInput.responsible = [];

        this.route2.params.subscribe((url: {id: string, code: string}) => {
           if(url.id) {
            this.getIdeaQuery = this.getIdeaGQL.watch({id: url.id});
            this.getIdeaQuery.valueChanges.subscribe(({data}) => {
                this.idea = data.getIdea as Idea;
    
                this.loading.hide();
            }, (error) => {
                super.onError(error);
            }); 
           }       
        });
    }

    ngAfterViewInit() {
        this.route2.params.subscribe(url => {
            if (!this.isNullOrUndefined(url)) {
                this.searchActionInput.idea = url.id;
                this.parmId = url.id;
            }
            this.configFilter();
            this.actionList();
        });
    }

    ngOnDestroy(): void {
        const elA = $('#modalAction');
        if (elA[0]) {
            elA.remove();
        }
    }

    transferInIdeaKaizen() {
        if (!this.parmId) return super.onError('Id não encontrado. Selecione uma ideia')

            const model = {
                authorName: this.idea?.authorName,
                title: this.idea?.title,
                re: this.idea?.re,
                description: this.idea?.description,
                document: this.idea?.document,
                email: this.idea?.email,
                frame: '8ab7658c-ff7b-403d-964e-f6eca746649f',
                role: this.idea?.role,
                turn: this.idea?.turn,
                userId: this.user?.id,
                area: 'pendente',
                problem: this.idea?.description,
                solution: 'Pendente de preenchimento pelo responsável',
                code: this.idea?.code,
              };

            this.createKaizenIdeaGQL.mutate({data: model}).subscribe(
                (response) => {
                    this.newIdeaKaizenId = response.data.createIdeaKaizen.id;
                    this.updateIdeaInput = {id: this.idea.id, ideaKaizenId: this.newIdeaKaizenId, status: 'converted'};
                    this.UpdateIdeaGQL.mutate({input: this.updateIdeaInput}).subscribe(
                        async () => {}, (err) => {
                            super.onError(err)
                        });
                    this.showMessage('Sucesso!', `Ideia convertida com sucesso`, 'success');
                    this.updateIdeaStatus();
                }, (error) => {
                    super.onError(error)
                }
              )
    }

    updateIdeaStatus() {
        this.updateIdeaStatusInput = {id: this.idea.id, status: 'converted'};
        this.UpdateIdeaStatusGQL.mutate({input: this.updateIdeaStatusInput}).subscribe(
            async () => {
                this.showMessage('Sucesso!', `Status alterado com sucesso!`, 'success');
                location.reload();
            }, 
            err => super.onError(err)
        );
    }

    configFilter() {
        this.getIdeasGQL.watch({status: ['approved', 'denied', 'awarded', 'analysis']}).valueChanges.subscribe(({data}) => {
            this.listIdeas = data.ideaByStatus as Idea[];
            const idea = this.listIdeas.find((e) => e.id === this.parmId);
            if (!this.isNullOrUndefined(idea)) {
                this.selectedUnityItems = [{id: idea.id, nameCode: idea.nameCode}];
            }
        });
        this.getUnitiesGQL.watch().valueChanges.subscribe(({data}) => {
            this.listUnity = data.getUnities as Unity[];
        });
        this.getCountriesGQL.watch().valueChanges.subscribe(({data}) => {
            this.listCountry = data.getCountries as Country[];
        });
        this.committeesGQL.watch().valueChanges.subscribe(({data}) => {
            this.listCommittee = data.committees as Committee[];
        });

        if (!this.isNullOrUndefined(this.searchActionInput.idea)) {
            this.getIdeaCommiteeByIdGQL.watch({input: this.searchActionInput.idea}).valueChanges.subscribe(({data}) => {
                const a = data.getIdea as Idea;
                this.listUser = a.committee.participants as User[];
            });
        } else {
            this.getUsersGQL.watch().valueChanges.subscribe(({data}) => {
                this.listUser = data.getUsers as User[];
            });
        }

        this.setDatePicker('picker-period', (start, end, label) => {
            this.searchActionInput.start = start.utcOffset(0, true).format();
            this.searchActionInput.end = end.utcOffset(0, true).format();
        });

    }

    actionList() {
        this.searchActionQuery = this.searchActionGQL.watch({input: this.searchActionInput});
        this.searchActionQuery.valueChanges.subscribe(({data}) => {
            this.listKamban = data.searchAction as Kamban[];
        });
    }

    actionSearch() {
        this.searchActionQuery.refetch({input: this.searchActionInput});
    }

    newSelectIdea(select = this.statusKamban[0]) {
        this.file = null;
        this.selectStatus = select;
        if (this.isNullOrUndefined(this.searchActionInput.idea)) {
            this.selectIdea = undefined;
            this.getIdeasGQL.watch({status: ['analysis']}).valueChanges.subscribe(({data}) => {
                this.listIdeasAction = data.ideaByStatus as Idea[];
            });
            super.showModal('modalIdea');
        } else {
            this.getIdeasById();
        }
    }

    getIdeasById() {
        this.getIdeaGQL.watch({id: this.searchActionInput.idea}).valueChanges.subscribe(({data}) => {
            this.selectIdea = data.getIdea as Idea;
            this.newAction(false);
        });
    }

    newAction(modalIdea = true) {
        if (modalIdea) {
            super.closeModal('modalIdea');
        }
        if (this.selectIdea.status !== 'analysis') {
            return this.showMessage('Atenção', 'É permitido criar ação apenas de ideias em análise');
        }
        this.modelAction = new Action();
        this.modelAction.endDate = this.dateNow;
        this.modelAction.startDate = this.dateNow;
        this.modelAction.status = this.selectStatus;
        this.responsible = undefined;
        this.comments = undefined;
        this.task = undefined;
        this.modelAction.idea = this.selectIdea;
        this.configAction();
        super.showModal('modalAction');
    }

    updateAction(event: Action) {
        this.modelAction = Object.assign({}, event);
        this.searchActionHistoryQuery = this.searchActionHistoryGQL.watch({id: this.modelAction.id, page: this.page});
        this.searchActionHistoryQuery.valueChanges.subscribe(({data}) => {
            this.modelActionHistory = data.actionHistory as ActionHistoryPage;
        });
        this.route2.params.subscribe(url => {
            if (!this.isNullOrUndefined(url)) {
                this.searchActionInput.idea = url.id;
            }
        });
        this.responsible = Object.assign({}, event).responsible?.id;
        this.comments = undefined;
        this.task = undefined;
        this.configAction();
        super.showModal('modalAction');
    }

    configAction() {
        this.setDate('picker-action', (start, end) => {
            this.modelAction.endDate = end.utcOffset(0, true).format();
        }, this.modelAction.endDate);

        this.setDate('picker-action-start', (start, end) => {
            this.modelAction.startDate = start.utcOffset(0, true).format();
        }, this.modelAction.startDate);
    }

    async onSave() {
        const arrValidateFields = [
            {value: this.modelAction.title, text: 'Titulo<br>'},
            {value: this.modelAction.description, text: 'Descrição<br>'},
            {value: this.modelAction.status, text: 'Status<br>'},
            {value: this.responsible, text: 'Responsável<br>'},
        ];
        const stringError = this.validateField(arrValidateFields);

        if (!super.isNullOrUndefined(stringError)) {
            this.showMessage('Atenção', `Preencha os campos corretamente: <br> ${stringError}`);
            return;
        }

        if (!super.isNullOrUndefined(this.files)) {
            try {
                await this.uploadFile();
            } catch(error) {
                console.log('Upload File Error: ', error);
            }
        }

        if (super.isNullOrUndefined(this.modelAction.id)) {
            this.actionCreatedAction();
        } else {
            this.actionUpdateAction();

            this.createActionFile(this.modelAction.id);
        }

        this.files = [];
    }

    async actionCreatedAction() {
        const createActionResponsibleInput: CreateActionResponsibleInput = {id: this.responsible};
        const CreateActionIdeaInput: CreateActionIdeaInput = {id: this.modelAction.idea.id};
        const input: CreateActionInput = {
            title: this.modelAction.title,
            description: this.modelAction.description,
            ideaId: CreateActionIdeaInput.id,
            responsibleId: createActionResponsibleInput.id,
            startDate: this.modelAction.startDate,
            endDate: this.modelAction.endDate,
            status: this.modelAction.status,
        };
        this.loading.show();

        this.createActionGQL.mutate({ input }).subscribe(
            ({data}) => {
                if (!super.isNullOrUndefined(this.modelAction.comments)) {
                    this.modelAction.comments.forEach((e) => {
                        this.actionComment(data.createAction.id, e.comment);
                    });
                }
                if (!super.isNullOrUndefined(this.modelAction.tasks)) {
                    this.modelAction.tasks.forEach((e) => {
                        this.actionTask(data.createAction.id, e.description);
                    });
                }
                
                this.createActionFile(data.createAction.id);
                
                setTimeout(() => {
                    this.searchActionQuery.refetch({input: this.searchActionInput});
                    this.loading.hide();
                    super.closeModal('modalAction');
                    this.showMessage(this.translate.instant('baseComponent.success'), this.translate.instant('acaocriada'), 'success');
                }, 1000);
            }, err => super.onError(err)
        );
    }

    actionUpdateAction() {
        const createActionResponsibleInput: CreateActionResponsibleInput = {id: this.responsible};
        const CreateActionIdeaInput: CreateActionIdeaInput = {id: this.modelAction.idea.id};
        const input: UpdateActionInput = {
            id: this.modelAction.id,
            title: this.modelAction.title,
            description: this.modelAction.description,
            idea: CreateActionIdeaInput,
            responsible: createActionResponsibleInput,
            startDate: this.modelAction.startDate,
            endDate: this.modelAction.endDate,
            status: this.modelAction.status
        };
        this.loading.show();
        this.updateActionGQL.mutate({input: input}).subscribe(
            () => {
                this.loading.hide();
                setTimeout(() => {
                    super.closeModal('modalAction');
                    this.showMessage('Sucesso!', `Atualização realizada com sucesso!`, 'success');
                    this.searchActionQuery.refetch({input: this.searchActionInput});
                }, 500);
            }, err => super.onError(err)
        );
    }

    createActionFile(actionId: string) {
        this.modelAction?.files?.forEach(f => {
            this.fileService.createActionFile(actionId, f).subscribe(
                () => {
                    this.loading.hide();
                },
                error => {
                    this.loading.hide();
                    this.showMessage('Erro', error)
                }
              );
        });
    }

    onComment() {
        if (super.isNullOrUndefined(this.comments)) {
            return this.showMessage('Atenção', `Digite uma mensagem antes de enviar!`);
        }
        if (super.isNullOrUndefined(this.modelAction.id)) {
            this.pushComment();
        } else {
            this.actionComment(this.modelAction.id, this.comments);
        }
        this.comments = undefined;
    }

    pushComment() {
        this.userService.user.subscribe((data) => {
            this.modelAction.comments = Object.assign([], this.modelAction.comments);
            let comment: ActionComment = new ActionComment();
            comment.comment = this.comments;
            comment.createdAt = this.dateNow;
            comment.user = data;
            this.modelAction.comments.push(comment);
        });
    }

    actionComment(id: string, comments: string) {
        this.modelAction.comments = Object.assign([], this.modelAction.comments);
        const action: CreateActionCommentActionInput = {id: id};
        const input: CreateActionCommentInput = {action: action, comment: comments};

        this.createActionCommentGQL.mutate({input: input}).subscribe(
            ({data}) => {
                this.modelAction.comments.push(data.createActionComment as ActionComment);
                this.searchActionQuery.refetch({input: this.searchActionInput});
            }, err => super.onError(err)
        );
    }

    onTask() {
        if (super.isNullOrUndefined(this.task)) {
            return this.showMessage('Atenção', `Digite uma ação antes de enviar!`);
        }
        if (super.isNullOrUndefined(this.modelAction.id)) {
            this.pushTask();
        } else {
            this.actionTask(this.modelAction.id, this.task);
        }
        this.task = undefined;
    }

    pushTask() {
        this.modelAction.tasks = Object.assign([], this.modelAction.tasks);
        let task: ActionTask = new ActionTask();
        task.description = this.task;
        this.modelAction.tasks.push(task);
    }

    actionTask(id: string, task: string) {
        this.modelAction.tasks = Object.assign([], this.modelAction.tasks);
        const action: CreateActionCommentActionInput = {id: id};
        const input: CreateActionTaskInput = {action: action, description: task};

        this.createActionTaskGQL.mutate({input: input}).subscribe(
            ({data}) => {
                this.modelAction.tasks.push(data.createActionTask as ActionTask);
                this.searchActionQuery.refetch({input: this.searchActionInput});
            }, err => super.onError(err)
        );
    }

    updateTaskStatus(task: ActionTask) {
        this.updateActionTaskStatusGQL.mutate({id: task.id}).subscribe(
            ({data}) => {
                this.searchActionQuery.refetch({input: this.searchActionInput});
            }, err => super.onError(err)
        );
    }

    removeActionTask(index: number) {
        super.confirmMessage('Atenção', 'Deseja realmente excluir essa tarefa?', () => {
            if (super.isNullOrUndefined(this.modelAction.id)) {
                return this.modelAction.tasks.splice(index, 1);
            }
            this.removeActionTaskGQL.mutate({id: this.modelAction.tasks[index].id}).subscribe(
                ({data}) => {
                    this.modelAction.tasks = Object.assign([], this.modelAction.tasks);
                    this.modelAction.tasks.splice(index, 1);
                    this.showMessage('Sucesso!', `Remoção realizada com sucesso!`, 'success');
                    this.searchActionQuery.refetch({input: this.searchActionInput});
                }, err => super.onError(err));
        });
    }

    async removeFile(index: number) {
        await this.removeFileFromBucket(this.modelAction.files[index].id);

        this.removeActionFileGQL.mutate({id: this.modelAction.files[index].id}).subscribe(
            ({}) => {
                this.modelAction.files = Object.assign([], this.modelAction.files);
                this.modelAction.files.splice(index, 1);
                this.showMessage('Sucesso!', `Remoção realizada com sucesso!`, 'success');
                this.searchActionQuery.refetch({input: this.searchActionInput});
            }, err => super.onError(err));
    }

    async removeFileFromBucket(id: string) {
        try {
            const file = await this.fileService.getActionFileById(id);

            await this.fileService.deleteActionFileFromBucket(file);
        } catch (error) {
            this.showMessage('Erro', error);
        }
    }

    handleUpload(event) {
        this.files.push(event.target.files[0]);
        this.file = this.files[this.files.length - 1];
        const type = this.file.type.split('/')[1];

        if (this.file.size > 0 && !extensions.includes(type)) {
            super.showMessage(
                this.translate.instant('baseComponent.warningAttention'), 
                this.translate.instant('warningUploadExtensions'),
                'info');
            return;
        }

        const reader = new FileReader();
        reader.onload = (_event) => {
            this.thumpName = this.file.name;

            imageTypes.includes(type) ? 
            this.thumpPath.push(_event.target.result) :
            this.thumpPath.push(type);
        };

        reader.readAsDataURL(event.target.files[0]);

        event.target.value = null;
    }

    async uploadFile() {
        this.loading.show();
        
        const uploadPromises = this.files.map(f => {
            return new Promise<ActionFile>((resolve, reject) => {
                this.fileService.uploadFile('Action', f).subscribe(
                    (response) => {
                        let actionFile = new ActionFile();
                        actionFile.fileName = response['fileName'];
                        actionFile.bucketRequestId = response['requestId'];
                        actionFile.url = environment.bucketUrl + response['fileName'];
                        actionFile.name = f.name;
                        actionFile.eTag = response['eTag'];
                        actionFile.versionId = response['versionId'];

                        resolve(actionFile);
                    },
                    (error) => {
                        super.showMessage('Error:', error.message);
                        reject(error);
                    }
                );
            });
        });
    
        try {
            const actionFiles = await Promise.all(uploadPromises);
            if (!this.modelAction.files) {
                this.modelAction.files = [];
            }
            this.modelAction.files = [...this.modelAction.files, ...actionFiles];
        } catch (error) {
            this.showMessage('Erro', error)
        }
    
        this.loading.hide();
    }

    onUpdateStatus() {
        if (this.isNullOrUndefined(this.modelAction.id)) {
            return;
        }
        this.updateActionStatusGQL.mutate({
            id: this.modelAction.id,
            status: this.modelAction.status
        }).subscribe(({data}) => {
            this.searchActionQuery.refetch({input: this.searchActionInput});
        }, error => super.onError(error));

    }

    getCurrentStatus(event) {
        this.currentStatus = event;
    }

    updateList() {
        this.searchActionQuery.refetch({input: this.searchActionInput});
    }

    removeActionFile(index: number) {
        super.confirmMessage('Atenção', 'Deseja realmente excluir esse anexo?', () => {
            this.loading.show();

            if(this.modelAction.files?.length > 0){
                this.removeFile(index);
            } else {
                this.files.splice(index, 1);
                this.thumpPath.splice(index, 1);
            }

            this.loading.hide();
        });
    }

    actionSearchPage() {
        this.loading.show();
        this.searchActionHistoryQuery.refetch({
            id: this.modelAction.id,
            page: this.page
        }).finally(() => this.loading.hide());
    }

    pageChanged(event) {
        this.page = event;
        this.actionSearchPage();
    }

    onItemSelectUnities(item: any) {
        this.searchActionInput.idea = item.id;
    }

    onItemDeselectUnities(item: any) {
        this.searchActionInput.idea = undefined;
    }

    selectIdeaByAction(item: any) {
        this.selectIdea = this.listIdeasAction.find(e => e.id == item.id);
    }

    deSelectIdeaByAction(item: any) {
        this.selectIdea = undefined;
    }

    selectResponsible(item: any) {
        this.searchActionInput.responsible.push(item.id);
    }

    deSelectResponsible(item: any) {
        const index = this.searchActionInput.responsible.indexOf(item.id);
        if (index > -1) {
            this.searchActionInput.responsible.splice(index, 1);
        }
    }

    selectedAllResponsible(item: any) {
        this.searchActionInput.responsible = [];
        item.forEach((e) => {
            this.searchActionInput.responsible.push(e.id);
        });
    }

    actionCleanFilter() {
        this.searchActionInput = new SearchActionInput();
        this.selectedItemsResponsible = [];
        this.selectedUnityItems = undefined;
        this.committee = [];
    }

    getType(file: any): boolean {
        if (file.type) {
            return imageTypes.some(type => file.type === mimeTypePrefix + type);
        } else if (file.name) {
            const extension = this.getFileExtension(file.name);
            return imageTypes.includes(extension);
        }
    }

    typeFileUpdate(file: any, thumbPath: string) {
        if (!this.getType(file)) {
            const type = this.getFileExtension(thumbPath);
            switch (type) {
                case 'pdf':
                    return 'assets/svg/pdf.svg';
                case 'ppt':
                case 'pptx':
                    return 'assets/svg/ppt.svg';
                case 'xls':
                case 'xlsx':
                    return 'assets/svg/xls.svg';
                default:
                    return 'assets/svg/doc.svg';
            }
        }
    }

    getFiles() {
        return this.modelAction.files ? this.modelAction.files : this.files;
    }
    
    getThumbPath(file, index) {
        return this.modelAction.files ? this.imageUrl + file.fileName : this.thumpPath[index];
    }

    getFileExtension(filePath: string) {
        return filePath?.split('.').pop()?.toLowerCase();
    }

    userProfile() {
        switch (this.user.role) {
            case 'admin':
                this.addAction = true;
                this.unityCountry = true;
                break;
            case 'user':
                this.addAction = true;
                this.unityCountry = true;
                break;
            case 'corporate-manager':
                this.addAction = true;
                this.unityCountry = true;
                break;
            case 'local-manager':
                this.addAction = true;
                this.unityCountry = true;
                break;
            case 'committee-member':
                this.addAction = false;
                this.unityCountry = false;
                break;
        }
    }

    onSelectDropCommitte($event: [Committee]) {
        this.searchActionInput.committee = $event.map(value => value.id);
    }
}
